import states from '../states';
import WIDGED_SEND_MESSAGE_TYPES from './widget.send.message.types';
import { detect, OperatingSystem } from 'detect-browser';

export default class WidgetService {
    [x: string]: any;
 	 static $inject = ['Router','$window','WIDGET_ID','$q'];
    constructor(Router, $window, WIDGET_ID, $q) {
        this.router = Router;
        this.$window = $window;
        this.WIDGET_ID = WIDGET_ID;
        this.$q = $q;
    }

    getWidget() {
        if (this.isChromeDesktop()) {
            this.sendMessage(WIDGED_SEND_MESSAGE_TYPES.OPEN_WIDGET).then(response => {
                if (!response) {
                  this.router.navigateByUrl('/extension');
                }
            });
        } else {
          this.router.navigateByUrl('/extension');
        }
    }

    isMobile(os: OperatingSystem | NodeJS.Platform) {
      return os === "Android OS" || os === "iOS"
    }

    isChromeDesktop() {
      const userBrowser = detect();
      return !this.isMobile(userBrowser.os) && userBrowser.name === 'chrome';
    }

    sendMessage(message) {
        if(!this.isChromeDesktop()) return this.$q.resolve(null);
        return this.$q(resolve => {
          if (window['chrome'] && window['chrome'].runtime) {
            window['chrome'].runtime.sendMessage(this.WIDGET_ID, message, (response) => resolve(response))
          }
        })
    }

    sendToken(token) {
        return this.sendMessage(Object.assign(WIDGED_SEND_MESSAGE_TYPES.SEND_TOKEN, { token }));
    }

    getToken() {
        return this.sendMessage(WIDGED_SEND_MESSAGE_TYPES.GET_TOKEN);
    }
}
